import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { cetra_item } from "../../../json/cetra";
import "../stylessh.css";

const Cetra = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderText = () => {
    return (
      <div>
        {cetra_item.map((item, index) => (
          <div key={index}>
            {item.cetra_item_title && <h2>{item.cetra_item_title}</h2>}
            {item.cetra_item_text && <p className="text-justify">{item.cetra_item_text}</p>}
            {item.cetra_item_links && (
              <ul className="list-mark">
                {item.cetra_item_links.map((link, linkIndex) => (
                  <li key={linkIndex} style={{ display: "inline-block", marginRight: "97px" }}>
                    <a href={link.url}>{link.label}</a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    );
  };
  
  

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Centro Estatal de Trasplantes</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {renderText()}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3746.4134966525257!2d-98.7267212824615!3d20.116785160807208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d109e079b39ccd%3A0xe7af2cf2c56534e2!2sDr+Alfonso+G+Alarc%C3%B3n+502%2C+Doctores%2C+Pachuca+de+Soto%2C+Hgo.!5e0!3m2!1ses!2smx!4v1556043946161!5m2!1ses!2smx"
            width="100%"
            height="300"
            frameBorder="0"
            style={{ border: 0, marginBottom: 50 }}
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Cetra;
